import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

/* small helper: close when you click outside */
function useClickAway(cb) {
  const ref = useRef(null);
  useEffect(() => {
    const handler = (e) => ref.current && !ref.current.contains(e.target) && cb();
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [cb]);
  return ref;
}

const LANGS = [
  { code: "en", label: "English", flag: "/images/flags/en.svg" },
  { code: "es", label: "Español", flag: "/images/flags/es.svg" }
];

export default function LanguageToggle() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useClickAway(() => setOpen(false));
  const navigate = useNavigate();
  const { pathname, search, hash } = useLocation();

  /* switch language AND move to the matching URL tree (/… ↔ /es/…) */
  const choose = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
    /* collapse leading slashes: on //evil.com this would otherwise send us off-site */
    const path = pathname.replace(/^[/\\]+/, "/");
    const base = path.replace(/^\/es(?=\/|$)/, "") || "/";
    const target = code === "es" ? (base === "/" ? "/es" : `/es${base}`) : base;
    if (target !== path) navigate(`${target}${search}${hash}`);
  };

  const current = LANGS.find(l => i18n.language.startsWith(l.code)) || LANGS[0];

  return (
    <div ref={ref} className="relative">
      {/* button */}
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1 rounded-full border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-800 hover:bg-gray-100"
      >
        <img src={current.flag} alt={current.code} className="h-4 w-4" />
        {current.code.toUpperCase()}
        <svg className="h-3 w-3 ml-0.5" viewBox="0 0 10 6" fill="none">
          <path d="M1 1l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </button>

      {/* dropdown */}
      {open && (
        <ul className="absolute right-0 mt-2 w-36 bg-white border border-gray-200 rounded-lg shadow-lg overflow-hidden z-50">
          {LANGS.map(l => (
            <li key={l.code}>
              <button
                onClick={() => choose(l.code)}
                className={`flex w-full items-center gap-2 px-3 py-2 text-sm ${
                  l.code === current.code ? "bg-[#E0F7F7] font-semibold" : "hover:bg-[#13C5C5]/10"
                }`}
              >
                <img src={l.flag} alt={l.code} className="h-4 w-4" />
                {l.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

